import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\Partners\SendDocumentToFuneUpController::__invoke
* @see app/Http/Controllers/Dossier/Partners/SendDocumentToFuneUpController.php
* @route '/api/dossier/{dossier}/funeup/media/{media}'
*/
const SendDocumentToFuneUpController = (args: { dossier: string | number | { id: string | number }, media: string | number | { id: string | number } } | [dossier: string | number | { id: string | number }, media: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: SendDocumentToFuneUpController.url(args, options),
    method: 'post',
})

SendDocumentToFuneUpController.definition = {
    methods: ["post"],
    url: '/api/dossier/{dossier}/funeup/media/{media}',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Dossier\Partners\SendDocumentToFuneUpController::__invoke
* @see app/Http/Controllers/Dossier/Partners/SendDocumentToFuneUpController.php
* @route '/api/dossier/{dossier}/funeup/media/{media}'
*/
SendDocumentToFuneUpController.url = (args: { dossier: string | number | { id: string | number }, media: string | number | { id: string | number } } | [dossier: string | number | { id: string | number }, media: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
            media: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
        media: typeof args.media === 'object'
        ? args.media.id
        : args.media,
    }

    return SendDocumentToFuneUpController.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace('{media}', parsedArgs.media.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\Partners\SendDocumentToFuneUpController::__invoke
* @see app/Http/Controllers/Dossier/Partners/SendDocumentToFuneUpController.php
* @route '/api/dossier/{dossier}/funeup/media/{media}'
*/
SendDocumentToFuneUpController.post = (args: { dossier: string | number | { id: string | number }, media: string | number | { id: string | number } } | [dossier: string | number | { id: string | number }, media: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: SendDocumentToFuneUpController.url(args, options),
    method: 'post',
})

export default SendDocumentToFuneUpController